// File path: src/project-portal/pages/Whatsapp/index.js
import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  Checkbox,
  FormControlLabel,
  Button,
  Grid,
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Badge,
  CircularProgress,
} from "@mui/material";
import PageHeader from "../../../components/PageHeader/PageHeader";
import ChatBox from "./elements/WhatsappChatBox";
import { WhatsappTemplatesAPI } from "../../../api/Endpoints/WhatsappTemplateAPI";
import moment from "moment";
import MultiTemplateSender from "./elements/MultiTemplateSender";
import { Waveform } from "@uiball/loaders";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import Pusher from "pusher-js";
import TextsmsIcon from "@mui/icons-material/Textsms";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import ImageIcon from "@mui/icons-material/Image";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import PictureAsPdfIcon from "@mui/icons-material/InsertDriveFile";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import WhatsappLeadConvrter from "./elements/WhatsappLeadConverter/WhatsappLeadConvrter";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import { toast } from "react-toastify";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import FilterBadges from "../../../components/FilterBadge/FilterBadges";
import { useLocation, useNavigate } from "react-router-dom"; // Added useNavigate for URL manipulation

function Index() {
  const [selectedChats, setSelectedChats] = useState([]);
  const [clickedMessage, setClickedMessage] = useState(null);
  const [multipSelector, setMultiSelector] = useState(false);
  const [openMultiSendPopup, setMultiSendPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [chats, setChats] = useState([]);
  const [UserName, setUserName] = useState(null);
  const [PhoneNumber, setPhoneNumber] = useState(null);
  const [TemplateData, setTemplateData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [WhatsappLeads, setWhatsappLeads] = useState([]);
  const [initLoading, setInitLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [FavIconLoading, setFavIconLoading] = useState(null);
  const userType = localStorage.getItem("role");
  const [refresh, setRefresh] = useState();
  
  const location = useLocation();
  const navigate = useNavigate(); // Added for URL manipulation
  const hasAutoOpenedRef = useRef(false); // Prevent re-opening on re-renders

  const tabIndexRef = useRef(tabIndex);

  // Handle URL query parameters for lead_id - only on initial load
  useEffect(() => {
    if (!hasAutoOpenedRef.current) {
      const queryParams = new URLSearchParams(location.search);
      const leadId = queryParams.get('lead_id');
      
      if (leadId) {
        // Find the chat with this lead_id and open it
        const chat = chats.find(chat => chat.lead_id === parseInt(leadId));
        if (chat) {
          setUserName(chat.lead_name);
          setPhoneNumber(chat.phone_number);
          setClickedMessage(chat.lead_id);
          hasAutoOpenedRef.current = true; // Mark as auto-opened
        } 
      }
    }
  }, [location.search, chats]);

  // Fetch specific chat when not found in current list
  const fetchSpecificChat = async (leadId) => {
    try {
      const res = await WhatsappTemplatesAPI.getRecendCommunications({ lead_id: leadId });
      if (res?.data?.length > 0) {
        const chat = res.data[0];
        setUserName(chat.lead_name);
        setPhoneNumber(chat.phone_number);
        setClickedMessage(chat.lead_id);
        hasAutoOpenedRef.current = true;
        
        // Add to chats list if not already present
        setChats(prevChats => {
          if (!prevChats.some(c => c.lead_id === chat.lead_id)) {
            return [chat, ...prevChats];
          }
          return prevChats;
        });
      }
    } catch (error) {
      console.error("Error fetching specific chat:", error);
    }
  };

  useEffect(() => {
    if (searchTerm || searchTerm == null) {
      console.log("searchTerm", searchTerm);
      
      fetchTableUpdate();
    } else {
      console.log("on no conditon serachTerm", searchTerm);
      fetchRecentChat();
    }
  }, [searchTerm]);

  const Tabs = [
    {
      label: "All",
      slug: "all",
    },
    {
      label: "Unread",
      slug: 0,
    },
    {
      label: "Favorites",
      slug: 1,
    },
  ];

  const handleSelect = (event, chat) => {
    event.stopPropagation();
    setSelectedChats((prev) => {
      const exists = prev.some((c) => c.lead_id === chat.lead_id);
      const newSelectedChats = exists
        ? prev.filter((c) => c.lead_id !== chat.lead_id)
        : [...prev, { lead_id: chat.lead_id, phone_number: chat.phone_number }];
      setMultiSelector(newSelectedChats.length > 1);
      return newSelectedChats;
    });
  };

  const handleSelectAll = (event) => {
    const currentChatIds = chats.map(chat => chat.lead_id);
    
    if (event.target.checked) {
      // Add all currently visible items
      const newSelections = chats.map(chat => ({
        lead_id: chat.lead_id,
        phone_number: chat.phone_number
      }));
      
      // Merge with existing selections
      const combinedSelections = [
        ...selectedChats.filter(selected => 
          !currentChatIds.includes(selected.lead_id)
        ),
        ...newSelections
      ];
      
      setSelectedChats(combinedSelections);
      setMultiSelector(combinedSelections.length > 1);
    } else {
      // Only remove currently visible items from selection
      const remainingSelections = selectedChats.filter(selected => 
        !currentChatIds.includes(selected.lead_id)
      );
      
      setSelectedChats(remainingSelections);
      setMultiSelector(remainingSelections.length > 1);
    }
  };

  const handleMessageClick = (chat) => {
    setUserName(chat.lead_name);
    setPhoneNumber(chat.phone_number);
    setClickedMessage(chat.lead_id);
  };

  const handleCloseChatBox = () => {
    // Remove lead_id parameter from URL when closing
    const queryParams = new URLSearchParams(location.search);
    queryParams.delete('lead_id');
    navigate(`${location.pathname}?${queryParams.toString()}`, { replace: true });
    
    // Close the chat box
    setClickedMessage(null);
    setUserName(null);
    setPhoneNumber(null);
  };

  const formatChatTime = (date) => {
    const now = moment();
    const messageTime = moment(date);

    if (now.isSame(messageTime, "day")) {
      return messageTime.format("h:mm A");
    } else if (now.subtract(1, "day").isSame(messageTime, "day")) {
      return "Yesterday";
    } else {
      return messageTime.format("DD/MM/YYYY");
    }
  };

  const onMultiSend = () => {
    setMultiSendPopup(true);
  };

  useEffect(() => {
    const pusher = new Pusher("e9821283ae4e0a5b1271", {
      cluster: "ap2",
      forceTLS: true,
      enabledTransports: ["ws", "wss"],
    });

    const channel = pusher.subscribe("desai-channel");

    channel.bind("new-message", (data) => {
      fetchTableUpdate(true, tabIndexRef.current);
    });

    channel.bind("desai-event", (data) => {
      if (FavIconLoading === null) {
        fetchTableUpdate(true, tabIndexRef.current);
      }
    });

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
      pusher.disconnect();
    };
  }, [FavIconLoading]);

  useEffect(() => {
    if (refresh) {
      fetchTableUpdate(true, tabIndexRef.current);
    }
  }, [refresh]);

  useEffect(() => {
    tabIndexRef.current = tabIndex;
  }, [tabIndex]);

  const fetchTableUpdate = async (
    forceUpdate = false,
    currentTabIndex = tabIndexRef.current
  ) => {
    let res;
    try {
      const params = {};

      if (searchTerm) {
        params.name = searchTerm;
      }

      if (currentTabIndex === 1) {
        params.read = 0;
        params.type = "received";
      } else if (currentTabIndex === 2) {
        params.favorites = 1;
      }

      res = await WhatsappTemplatesAPI.getRecendCommunications(params);

      if (forceUpdate || currentTabIndex === tabIndexRef.current) {
        setChats(res?.data || []);
      }
    } catch (error) {
      console.error("Error fetching chats:", error);
      toast.error("Failed to load chats");
    }
  };

  const handleTabChange = async (data, index) => {
    setSelectedChats([]);
    setMultiSelector(false);
    setSearchTerm(null)
    if (tabIndex === index) return;
    setTabIndex(index);
    let res;
    setLoading(true);
    
    if (data.slug === "all") {
      res = await WhatsappTemplatesAPI.getRecendCommunications();
    }
    if (data.slug === 0) {
      console.log("working");
      
      res = await WhatsappTemplatesAPI.getRecendCommunications({ read: 0, type: 'received' });
    } else if (data.slug === 1) {
      res = await WhatsappTemplatesAPI.getRecendCommunications({
        favorites: 1,
      });
    }
    setChats(res?.data || []);
    setLoading(false);
  };

  const fetchRecentChat = async () => {
    setInitLoading(true);
    const res = await WhatsappTemplatesAPI.getRecendCommunications({
      name: searchTerm,
    });
    setChats(res?.data || []);
    setLoading(false);
    setInitLoading(false);
  };

  useEffect(() => {
    fetchLeadListWhatsapp();
  }, []);

  const [wLoading, setWloading] = useState(false);
  const fetchLeadListWhatsapp = async () => {
    setWloading(true);
    const res = await WhatsappTemplatesAPI.getLeadWhatsappList();
    setWhatsappLeads(res?.data || []);
    setWloading(false);
  };

  const handleFavroiteClick = async (leadId, chatIndex) => {
    setFavIconLoading(chatIndex);
    try {
      const res = await WhatsappTemplatesAPI.addToFavorites({
        lead_id: leadId,
      });

      if (res.data.message) {
        toast.success(res.data.message, { autoClose: 2000 });
      }

      if (tabIndex === 2) {
        await fetchTableUpdate(tabIndex);
      } else {
        setChats((prevChats) =>
          prevChats.map((chat) =>
            chat.lead_id === leadId
              ? { ...chat, wa_favorite: chat.wa_favorite === 1 ? 0 : 1 }
              : chat
          )
        );
      }
    } catch (error) {
      toast.error("Failed to update favorite status");
      await fetchTableUpdate(tabIndex);
    } finally {
      setFavIconLoading(null);
    }
  };

  return (
    <>
      <div className="page-cntr">
        <div className="lead-cntr follo-up-cntr">
          <div className="lead-table lead-page-cntr">
            <div className="title-sec">
              <Card
                sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}
              >
                <PageHeader title={"WhatsApp"} />
              </Card>
            </div>
          </div>

          {initLoading ? (
            <Box
              sx={{
                width: "100%",
                marginTop: 10,
                height: 20,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Waveform size={40} lineWeight={3.5} speed={1} color="blue" />
            </Box>
          ) : (
            <Card
              sx={{ m: 0, p: 2 }}
              variant="outlined"
              className="lead-table followup-table"
            >
              <Grid display={"flex"} alignItems={"center"}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        chats.length > 0 &&
                        chats.every(chat => 
                          selectedChats.some(selected => selected.lead_id === chat.lead_id)
                        )
                      }
                      indeterminate={
                        selectedChats.length > 0 &&
                        !chats.every(chat => 
                          selectedChats.some(selected => selected.lead_id === chat.lead_id)
           ) }
                      onChange={handleSelectAll}
                    />
                  }
                  sx={{ pl: 2, mb: 1, ml: 0.2 }}
                />
                <TextField
                  className="searchbox"
                  fullWidth
                  variant="outlined"
                  placeholder="Search...."
                  value={searchTerm == null ? "" : searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{ mb: 2, width: 300 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          edge="end"
                          onClick={() => {
                            setSearchTerm(null);
                            setMultiSelector(false);
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              <Grid container alignItems="center" spacing={2} sx={{ width: "100%", pl: 2 }}>
  {/* Tabs section - will take available space */}
  <Grid item xs={8} md={9} lg={10}>
    <Box display="flex" gap={1}>
      {Tabs.map((tab, index) => (
        <Button
          key={index}
          variant="contained"
          onClick={() => handleTabChange(tab, index)}
          sx={{
            backgroundColor: tabIndex === index ? "#0053A0" : "#E2E8F0",
            color: tabIndex === index ? "white !important" : "black",
            "&:hover": {
              backgroundColor: tabIndex === index ? "#0053A0" : "#f5f5f5",
            },
            whiteSpace: 'nowrap',
            minWidth: '80px',
          }}
        >
          {tab.label}
        </Button>
      ))}
      {multipSelector && (
        <Button
          sx={{
            background: "#FAAB53",
            color: "white !important",
            "&:hover": { background: "#FAAB53" },
            whiteSpace: 'nowrap'
          }}
          onClick={onMultiSend}
        >
          Send Template
        </Button>
      )}
    </Box>
  </Grid>

  {/* Selection info - will align to right */}
  {multipSelector && selectedChats.length >= 1 && (
    <Grid item xs={4} md={3} lg={2}>
      <Box 
        sx={{ 
          backgroundColor: 'rgb(231,241,254)',
          display: "flex", 
          alignItems: "center",
          borderRadius: "5px",
          justifyContent: "flex-end",
          width: '130px',
          p: 1,
          ml: 'auto'
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 'bold', mr: 1 }}>
          Selected: {selectedChats.length}
        </Typography>
        <IconButton size="small" onClick={() => {
          setSelectedChats([]);
          setMultiSelector(false);
        }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Grid>
  )}
</Grid>
                {!clickedMessage &&
                  userType === "Manager" &&
                  !openMultiSendPopup &&
                  WhatsappLeads.length > 0 && (
                    <WhatsappLeadConvrter
                      leads={WhatsappLeads}
                      func={fetchLeadListWhatsapp}
                      loading={wLoading}
                    />
                  )}
              </Grid>
              {loading ? (
                <Box
                  sx={{
                    width: "100%",
                    marginTop: 10,
                    height: 50,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Waveform size={40} lineWeight={3.5} speed={1} color="blue" />
                </Box>
              ) : (
                <List>
                  {chats.length === 0 && (
                    <ListItem>
                      <ListItemText
                        primary={"Chats are empty"}
                        sx={{ textAlign: "center" }}
                      />
                    </ListItem>
                  )}
                  {chats.map((chat, index) => (
                    <ListItem
                      key={chat.lead_id}
                      sx={{
                        transition: "background-color 0.3s ease",
                        borderBottom: "1px solid #f0f2f5",
                        "&:hover": {
                          backgroundColor: "#f0f2f5",
                          borderLeft: "3px solid #25D366",
                        },
                        backgroundColor:
                          clickedMessage === chat.lead_id
                            ? "#e0e0e0"
                            : "transparent",
                      }}
                      onClick={() => handleMessageClick(chat)}
                    >
                      <Checkbox
                        checked={selectedChats.some(
                          (c) => c.lead_id === chat.lead_id
                        )}
                        onClick={(e) => handleSelect(e, chat)}
                      />

                      <ListItemAvatar>
                        <Badge
                          variant={
                            chat.is_read === 0 && chat.type === "received"
                              ? "dot"
                              : "standard"
                          }
                          color="success"
                          overlap="circular"
                          sx={{
                            "& .MuiBadge-badge": {
                              height: 15,
                              width: 15,
                              borderRadius: "50%",
                            },
                          }}
                        >
                          <Avatar
                            src={chat.avatar}
                            sx={{
                              cursor: "pointer",
                              transition:
                                "transform 0.2s ease, border 0.2s ease",
                              "&:hover": { transform: "scale(1.1)" },
                              "&:active": { border: "2px solid #1976d2" },
                            }}
                          />
                        </Badge>
                      </ListItemAvatar>

                      <ListItemText
                        className="message-name"
                        sx={{
                          cursor: "pointer",
                          "&:hover": { color: "#1976d2" },
                        }}
                        primary={chat.lead_name}
                        secondary={
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            display={"flex"}
                          >
                            <span>
                              {chat.type === "send" ? (
                                chat.wa_status === "read" ? (
                                  <DoneAllIcon
                                    sx={{ fontSize: 15, color: "blue" }}
                                  />
                                ) : chat.wa_status === "failed" ? (
                                  <ErrorOutlineIcon
                                    sx={{ fontSize: 15, color: "red" }}
                                  />
                                ) : (
                                  <DoneAllIcon sx={{ fontSize: 15 }} />
                                )
                              ) : null}
                            </span>

                            {chat.msg_type === "Text" ? (
                              <>
                                <TextsmsIcon
                                  fontSize="small"
                                  sx={{ verticalAlign: "middle", mr: 1 }}
                                />
                                {chat.message}
                              </>
                            ) : chat.msg_type === "Video" ? (
                              <>
                                <VideoLibraryIcon
                                  fontSize="small"
                                  sx={{ verticalAlign: "middle", mr: 1 }}
                                />
                                Video
                              </>
                            ) : chat.msg_type === "Document" ? (
                              <>
                                <PictureAsPdfIcon
                                  fontSize="small"
                                  sx={{ verticalAlign: "middle", mr: 1 }}
                                />
                                Document
                              </>
                            ) : chat.msg_type === "Text/Attach" ? (
                              <>
                                <AttachFileIcon
                                  fontSize="small"
                                  sx={{ verticalAlign: "middle", mr: 1 }}
                                />
                                Attach
                              </>
                            ) : chat.msg_type === "Image" ? (
                              <>
                                <ImageIcon
                                  fontSize="small"
                                  sx={{ verticalAlign: "middle", mr: 1 }}
                                />
                                Image
                              </>
                            ) : chat.msg_type === "Audio" ? (
                              <>
                                <KeyboardVoiceIcon
                                  fontSize="small"
                                  sx={{ verticalAlign: "middle", mr: 1 }}
                                />
                                Voice Message
                              </>
                            ) : null}
                            <span style={{ marginLeft: "5px",display:"flex",alignItems:"center" }}>
                            <FiberManualRecordIcon sx={{fontSize:8,marginLeft:0.5}}/> {formatChatTime(chat.created_at)}
                            </span>
                          </Typography>
                        }
                      />
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleFavroiteClick(chat.lead_id, index);
                        }}
                        disabled={FavIconLoading === index}
                      >
                        {FavIconLoading === index ? (
                          <CircularProgress
                            size={24}
                            sx={{ color: "#FAAB53" }}
                          />
                        ) : chat.wa_favorite === 1 ? (
                          <StarIcon sx={{ color: "#FAAB53" }} />
                        ) : (
                          <StarBorderIcon />
                        )}
                      </IconButton>
                    </ListItem>
                  ))}
                </List>
              )}
            </Card>
          )}
        </div>
      </div>

      <MultiTemplateSender
        open={openMultiSendPopup}
        setOpen={setMultiSendPopup}
        totalSelected={selectedChats.length}
        setTemplateData={setTemplateData}
        selectedChats={selectedChats}
        TableUpdate={fetchTableUpdate}
        setSelectedChats={setSelectedChats}
      
      />

      <ChatBox
        id={clickedMessage}
        setId={handleCloseChatBox}
        Name={UserName}
        TableUpdate={fetchTableUpdate}
        phone_number={PhoneNumber}
        setRefresh={setRefresh}
      />
    </>
  );
}

export default Index;